import { Models } from "api/types";

/**
 * Whitelist of all skincare-specific concerns from "Skin Clarity" and "Skin Texture" categories.
 * If a practice doesn't offer any of these concerns, we skip all skincare-related screens
 * (Heritage, Skin Color, Skin Sun, Skin Balance).
 */
export const SKINCARE_CONCERNS: readonly string[] = [
  // Skin Clarity
  "Acne",
  "Discoloration",
  "Redness",
  "Spider Veins",
  "Stretch Marks",
  "Hyperpigmentation",
  "Melasma",
  "Rosacea",
  "Age Spots",
  "Dark Spots",
  "Tattoo Removal",
  "Sun Damage",
  "Dull Skin",
  "Uneven Skin Tone",
  "Broken Capillaries",
  // Skin Texture
  "Enlarged Pores",
  "Loose Skin",
  "Scars",
  "Skin Rejuvenation",
  "Wrinkles",
  "Anti-aging",
  "Dry Skin",
  "Moles",
  "Varicose Veins",
  "Acne Scars",
  "Sagging Skin",
  "Fine Lines",
  "Cherry Angiomas",
  "Prejuvenation",
  "Volume Loss",
  "Skin Elasticity",
  "Collagen Stimulation",
  "Marionette Lines",
  "Smile Lines",
];

/**
 * Checks if any of the provided concerns are skincare-related.
 * Used to determine whether to show skincare screens in the personalization flow.
 */
export function hasSkincareConcerns(
  concerns: Models<"DisplayedConcern">[]
): boolean {
  return concerns.some((concern) => SKINCARE_CONCERNS.includes(concern.name));
}
